import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { companiesService, DeleteCompanyRequest } from '@aslanpay/portal-common-lib';

const useDeleteCompany = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, DeleteCompanyRequest>) => {
  return useMutation<unknown, Error, DeleteCompanyRequest>(
    ({ id }: DeleteCompanyRequest) => companiesService.deleteCompany(id),
    { onSuccess, onError }
  );
};

export default useDeleteCompany;
